import ImpressionIcon from '@/assets/svg/feature-impression.svg'
import TrustIcon from '@/assets/svg/feature-trust.svg'
import ContactlessIcon from '@/assets/svg/feature-contactless.svg'
import ExperienceIcon from '@/assets/svg/feature-experience.svg'
import NameCardIcon from '@/assets/svg/feature-name-card.svg'

const featureData = ($t) => {
  return [
    {
      icon: ImpressionIcon,
      title: $t.TXT_Feature_item1_title,
      item: [
        $t.TXT_Feature_item1_context1,
        $t.TXT_Feature_item1_context2,
        $t.TXT_Feature_item1_context3,
        $t.TXT_Feature_item1_context4
      ],
      hasDot: true,
    },
    {
      icon: TrustIcon,
      title: $t.TXT_Feature_item2_title,
      item: [
        $t.TXT_Feature_item2_context1,
        $t.TXT_Feature_item2_context2,
        $t.TXT_Feature_item2_context3,
        $t.TXT_Feature_item2_context4
      ],
      hasDot: true,
    },
    {
      icon: ContactlessIcon,
      title: $t.TXT_Feature_item3_title,
      item: [
        $t.TXT_Feature_item3_context1,
        $t.TXT_Feature_item3_context2,
        $t.TXT_Feature_item3_context3,
      ],
      hasDot: true,
    },
    {
      icon: ExperienceIcon,
      title: $t.TXT_Feature_item4_title,
      item: [
        $t.TXT_Feature_item4_context1,
        $t.TXT_Feature_item4_context2,
        $t.TXT_Feature_item4_context3,
      ],
      hasDot: true,
    },
    {
      icon: NameCardIcon,
      title: $t.TXT_Feature_item5_title,
      item: [
        $t.TXT_Feature_item5_context1,
        $t.TXT_Feature_item5_context2,
        $t.TXT_Feature_item5_context3,
      ],
      hasDot: true,
    },
  ]
}

export default featureData
